import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=3b5fcd16&scoped=true&"
import script from "./Interaction.vue?vue&type=script&lang=js&"
export * from "./Interaction.vue?vue&type=script&lang=js&"
import style0 from "./Interaction.vue?vue&type=style&index=0&id=3b5fcd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fcd16",
  null
  
)

component.options.__file = "Interaction.vue"
export default component.exports